<template>
  <div class="assistant-teacher-nav">
    <div class="nav-stage">
      <span class="nav-stage-label">1. ปฏิทิน / เรียกรายงานตัว / ตำแหน่งว่าง</span>
      <v-bottom-navigation color="info" horizontal dark>
        <v-btn to="/admin/periodassteach">
          <span>ปฏิทิน/กำหนดรอบ</span>
          <v-icon>mdi-calendar-clock</v-icon>
        </v-btn>
        <v-btn to="/admin/timelines/report_assistantteacher">
          <span>กำหนดการรายงานตัว</span>
          <v-icon>mdi-calendar-check</v-icon>
        </v-btn>
        <v-btn to="/admin/assistant_teacher_report/manage_college_manpower">
          <span>เลขที่ตำแหน่งว่าง</span>
          <v-icon>mdi-office-building-marker</v-icon>
        </v-btn>
        <v-btn to="/admin/assistant_teacher_report/teacher_college_manpower_report">
          <span>จับคู่ตำแหน่ง/รายงาน</span>
          <v-icon>mdi-swap-horizontal</v-icon>
        </v-btn>
        <v-btn to="/admin/manage_assistant_teacher_data">
          <span>ข้อมูลครูผู้ช่วยเรียกรายงานตัว</span>
          <v-icon>mdi-account-details</v-icon>
        </v-btn>
        <v-btn to="/admin/assistant_teacher_report/manage_assistant_CollegeReport">
          <span>รายงานตัว ณ สถานศึกษา</span>
          <v-icon>mdi-domain</v-icon>
        </v-btn>
        <v-btn to="/admin/assistant_teacher_report/manage_assistant_CollegeReportTran" class="mr-5">
          <span>รายงานตัว (โอนย้าย)</span>
          <v-icon>mdi-domain-switch</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </div>

    <div class="nav-stage">
      <span class="nav-stage-label">2. เสนอคณะกรรมการประเมิน</span>
      <v-bottom-navigation color="info" horizontal :background-color="color" dark>
        <v-btn to="/admin/assistant_teacher_report/assistantcommitteequalified">
          <span>ทะเบียนผู้ทรงคุณวุฒิ</span>
          <v-icon>mdi-account-star</v-icon>
        </v-btn>
        <v-btn to="/admin/assistant_teacher_report/manage_assistant_teacher_committee" class="mr-5">
          <span>เสนอคณะกรรมการรายคน</span>
          <v-icon>mdi-account-group</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </div>

    <div class="nav-stage">
      <span class="nav-stage-label">3. ประเมินตามรอบ / รายงานผล</span>
      <v-bottom-navigation color="info" horizontal :background-color="color" dark>
        <v-btn to="/admin/assistant_teacher">
          <span>การประเมิน/ตรวจสอบผล</span>
          <v-icon>mdi-clipboard-check-outline</v-icon>
        </v-btn>
        <v-btn to="/admin/assistant_teacher_reports">
          <span>รายงานสรุปผลคะแนน</span>
          <v-icon>mdi-chart-box-outline</v-icon>
        </v-btn>
        <v-btn to="/admin/assistant_teacher_detail">
          <span>ตรวจสอบรายละเอียดรายคน</span>
          <v-icon>mdi-account-search</v-icon>
        </v-btn>
        <v-btn to="/admin/servey_assistant_specialized_licenses" class="mr-5">
          <span>ใบอนุญาตประกอบวิชาชีพ</span>
          <v-icon>mdi-certificate-outline</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </div>

    <div class="nav-stage">
      <span class="nav-stage-label">4. อนุมัติ ครู คศ.1</span>
      <v-bottom-navigation color="info" horizontal :background-color="color" dark>
        <v-btn to="/admin/assistant_teacher_reports" class="mr-5">
          <span>รายงานผล + อนุมัติ คศ.1</span>
          <v-icon>mdi-file-certificate-outline</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </div>

    <div class="nav-stage">
      <span class="nav-stage-label">ตรวจสอบ / ข้อมูลย้อนหลัง</span>
      <v-bottom-navigation color="info" horizontal :background-color="color" dark>
        <v-btn to="/admin/assistant_teacher_monitor">
          <span>ตรวจสอบ/สถิติ/ไทม์ไลน์รายคน</span>
          <v-icon>mdi-radar</v-icon>
        </v-btn>
        <v-btn to="/admin/assistant_teacher_report/manage_assistant_teacher_backup" class="mr-5">
          <span>ข้อมูลย้อนหลัง</span>
          <v-icon>mdi-archive-outline</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </div>
  </div>
</template>

<script>
export default {
  name: "HRvecPersonnelmenu",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
  computed: {
    color() {
      return "#202224";
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-stage {
  margin-bottom: 2px;
}
.nav-stage-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  color: #616161;
  background: #f5f5f5;
  padding: 2px 12px;
}
</style>
